import { render, staticRenderFns } from "./run-table.vue?vue&type=template&id=ca3437c4&scoped=true&"
import script from "./run-table.vue?vue&type=script&lang=js&"
export * from "./run-table.vue?vue&type=script&lang=js&"
import style0 from "./run-table.vue?vue&type=style&index=0&id=ca3437c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3437c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
